<template>
    <v-container fluid>
        <v-btn @click="printReport" color="primary" :disabled="!report">Print</v-btn>
        <div v-html="report_template"></div>
    </v-container>
</template>

<script setup>
import { ref, defineProps, onMounted, inject } from "vue";
import * as tenderService from "@/services/tenderService";
import * as tdService from "@/services/tenderDetailService";
import { tenderReportTemplate, tenderReportItemTemplate } from "./tenderReportTemplates";
import moment from "moment";
// import { loadRouteLocation } from "vue-router";

const loader = inject("loader");
const snackbar = inject("snackBar");

const props = defineProps({
    tenderId: {
        type: String,
        required: true,
    },
})

let tender = {};
let reportData = [];

const report_template = ref("");
const report = ref("");

function getTemplate() {
    let temp = tenderReportTemplate;

    temp = temp.replace("#HIJRIYEAR", `${tender.hijriYear}H`);
    temp = temp.replace("#TENDERDATE", new moment(tender.tenderDate).format("D-MMM-yyyy"));

    let table_template = "";

    reportData.forEach(rpt => {
        let temp_item = tenderReportItemTemplate;

        temp_item = temp_item.replace("#ITEMNAME", rpt.itemName);

        let items = "";

        rpt.prices.forEach(it => {
            items += `<tr><td>${it.customerName}</td><td>${it.price}</td></tr>`;
        });

        temp_item = temp_item.replace("#ITEMS", items);

        table_template += temp_item;
    });

    temp = temp.replace("#ITEMTABLES", table_template);
    report_template.value = temp;
    report.value = temp;
}

async function printWhenReady(printWindow) {
    if (printWindow.document.fonts?.ready) {
        await Promise.race([
            printWindow.document.fonts.ready,
            new Promise((resolve) => setTimeout(resolve, 1000)),
        ]);
    }

    await new Promise((resolve) => {
        printWindow.requestAnimationFrame(() => {
            printWindow.requestAnimationFrame(() => {
                setTimeout(resolve, 100);
            });
        });
    });

    printWindow.focus();
    printWindow.print();
}

function printReport() {
    const newWindow = window.open("about:blank", "_blank");

    if (!newWindow) {
        snackbar.error("Please allow pop-ups to print the tender report.");
        return;
    }

    newWindow.document.write(report.value);
    newWindow.document.close();

    if (newWindow.document.readyState === "complete") {
        setTimeout(() => printWhenReady(newWindow), 0);
    } else {
        newWindow.addEventListener("load", () => setTimeout(() => printWhenReady(newWindow), 0), { once: true });
    }
}

onMounted(async () => {
    loader.show();

    try {
        const promises = [tenderService.tender_getById(props.tenderId), tdService.getReportByTenderId(props.tenderId)];
        const [getTender, getReport] = await Promise.all(promises);

        tender = getTender;
        reportData = getReport;

        getTemplate();
    } catch (ex) {
        snackbar.error(ex);
    } finally {
        loader.hide();
    }
});
</script>